<template>
  <div class="hero  is-fullheight">


    <section class="hero is-dark is-small is-bold">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h1 class="title">AOS Программа обучения.</h1>
        </div>
      </div>
    </section>


    <div class="hero-body ">
      <section class=" container has-text-centered ">
        <div class="column is-6 is-offset-3" >

          <div v-if="!currentUser" class="card article">
            <div class="card-content">
              <div class="media">
                <div class="media-content has-text-centered">
                  <p class="title article-title">Для начала авторизуйтесь в программе</p>
                </div>
              </div>
              <div class="content article-body is-center">
                <div class="buttons ">
                  <b-button type="is-primary" autofocus @click.prevent="attemptLogin">Войти</b-button>
                  <b-button v-if="!isZDAUrl" type="is-text" tag="a" :href="registrationPage" >Зарегистрироваться</b-button>
                </div>
              </div>
            </div>
          </div>



          <div v-else-if="currentUser" class="card article">
            <div class="card-content">
              <div class="content article-body">
                <h3><b-icon icon="lock" /> Вас давно не было.</h3>
              </div>
              <div class="media">
                <div class="media-center image is-128x128">
                  <b-image :src="currentUser.photoPath" ratio="1by1" rounded responsive class="author-image" alt="Placeholder image" />
                </div>
                <div class="media-content has-text-left pl-5">
                  <p class="title article-title">{{currentUser.fullName}}</p>
                  <div class="pt-2">
                    <div class="buttons">
                      <b-button icon-left="lock-open" type="is-primary" autofocus @click.prevent="attemptLogin">Войти</b-button>
                      <b-button type="is-text" tag="a" @click.prevent="logout()" >Выйти</b-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'
import HasErrors from '@/mixins/HasErrors'
import GlobalLoaderMixin from '@/mixins/GlobalLoaderMixin'
import OAuthClient from "@/helpers/oauth";
import IsZDAMixin from '../../../mixins/IsZDAMixin'


export default {
    mixins: [
        HasErrors,
        GlobalLoaderMixin,
        IsZDAMixin,
    ],
    data () {
        return {

        }
    },
    mounted () {
        if (this.isLoggedIn) {
            this.redirect()
        }
    },
    computed: {
        ...mapGetters({
            'isLoggedIn': 'e/users/isLoggedIn',
            'registrationPage': 'e/users/registrationPage',
            'currentUser': 'e/users/currentUser',
        }),
    },
    methods: {
        ...mapActions({
            'login': 'e/users/login',
            'logout': 'e/users/logout',
        }),
        redirect () {
            this.$router.push({ name: 'home' })
        },
        attemptLogin () {
            OAuthClient.login()
        },
    },
}
</script>
